module.exports = __webpack_public_path__ + "img/banner.73c5fba5.jpg";